function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#313D53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.816 8.83c-.726-.693-1.648-1.046-2.676-1.046-1.823 0-3.366 1.231-3.917 2.886-.14.42-.22.869-.22 1.33 0 .461.08.91.22 1.33.55 1.655 2.094 2.886 3.917 2.886.942 0 1.744-.248 2.37-.668a3.22 3.22 0 001.397-2.113H12.14v-2.708h6.593c.082.458.127.936.127 1.432 0 2.132-.764 3.926-2.087 5.145C15.615 18.374 14.03 19 12.14 19A6.997 6.997 0 015.885 8.856 6.997 6.997 0 0112.14 5c1.887 0 3.471.694 4.684 1.823l-2.008 2.008z",
  fill: "#fff"
})));